import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/Login';
import { LoginMfaPage } from './pages/LoginMfa';
import { LoginRecoveryPage } from './pages/LoginRecovery';
import { AccessRequestedPage } from './pages/AccessRequested';
import { RegisterPage } from './pages/Register';
import { OktaCallbackPage } from './pages/OktaCallback';
import { PrivacyPolicyPage } from './pages/PrivacyPolicy';
import { ChatPage } from './pages/Chat';
import { SettingsPage } from './pages/Settings';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { SignupRequestsPage } from './pages/admin/SignupRequestsPage';
import { ApproveSignupRequestPage } from './pages/admin/ApproveSignupRequestPage';
import { CryptoInventoryPage } from './pages/posture/CryptoInventoryPage';
import { useAuth } from './hooks/useAuth';

export function App() {
  const { isAuthenticated, isInitializing } = useAuth();

  // Wait for MSAL redirect handling before routing
  if (isInitializing) {
    return (
      <div className="login-container">
        <div className="login-card" style={{ alignItems: 'center', gap: 12 }}>
          <span className="login-logo-text">Cade</span>
          <span style={{ color: 'var(--color-text-muted)', fontSize: 14 }}>Signing in...</span>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/mfa" element={<LoginMfaPage />} />
      <Route path="/login/recovery" element={<LoginRecoveryPage />} />
      <Route path="/login/access-requested" element={<AccessRequestedPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/auth/okta/callback" element={<OktaCallbackPage />} />
      <Route path="/t/:tenant/auth/okta/callback" element={<OktaCallbackPage />} />
      <Route
        path="/settings"
        element={isAuthenticated ? <SettingsPage /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/projects"
        element={isAuthenticated ? <ProjectsPage /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/projects/:projectId"
        element={isAuthenticated ? <ProjectDetailPage /> : <Navigate to="/login" replace />}
      />
      {/* Public — no-login approve from the admin-signup-notification
          email. Token-authenticated; must sit before the login-gated
          queue route. Spec: approval-queue.md "Approve from the
          notification email". */}
      <Route
        path="/admin/signup-requests/approve"
        element={<ApproveSignupRequestPage />}
      />
      <Route
        path="/admin/signup-requests"
        element={isAuthenticated ? <SignupRequestsPage /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/posture/crypto-inventory"
        element={isAuthenticated ? <CryptoInventoryPage /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/*"
        element={isAuthenticated ? <ChatPage /> : <Navigate to="/login" replace />}
      />
    </Routes>
  );
}
